import Box from "@mui/material/Box";
import { EmptyState } from "components/EmptyState/EmptyState";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { ReactComponent as FileSearch02Icon } from "components/Icons/file-search-02.svg";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useNavigate } from "react-router-dom";
import { links } from "utilities/links";

export function ErrorPage() {
  const { message } = useMessage();
  const navigate = useNavigate();

  return (
    <>
      <TopHeader title="404" />
      <Box mt={24} />
      <EmptyState
        button={
          <OLButton
            color="primary"
            onClick={() => navigate(links.dashboard)}
            size="medium"
            variant="contained"
          >
            {message({ id: "backToDashboard" })}
          </OLButton>
        }
        description={message({ id: "404Info" })}
        icon={<FileSearch02Icon />}
        title={message({ id: "404Header" })}
      />
    </>
  );
}
